import type { TerminalClause } from '@atlaskit/jql-ast';
import { VALID_ASSIGNEE_OPERATORS } from '../../../common/constants.tsx';

/**
 * Check if assignee clause is valid (has valid operator = or IN only)
 */
export const validateClause = (clause: TerminalClause): boolean => {
	if (!clause) {
		return true;
	}
	return (
		clause.operator?.value !== undefined && VALID_ASSIGNEE_OPERATORS.has(clause.operator.value)
	);
};
